import { useStoreActions, useStoreState } from "easy-peasy";

const useAuth = () => {
  const user = useStoreState((state) => state.auth.user);
  const userLoading = useStoreState((state) => state.auth.loading);
  const userError = useStoreState((state) => state.auth.error);

  const handleLogout = useStoreActions((actions) => actions.auth.handleLogout);

  return { user, userLoading, userError, handleLogout };
};

export default useAuth;
